<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-05-23 14:52:38
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-06 15:26:27
-->
<template>
  <div>
       <a-drawer
    title="监测配置（栏目不更新）"
    :visible="visible"
    :width="width<=1000?'90%':'900px'"
    @close="onClose"
  >
    <div class="title-box">
      <i class="el-icon-info icon-title"></i>
      <div>
       <div> 1. 检测时间点前2周内的动态、要闻类栏目，以及检测时间点前6个月内的通知公告、政策文件类一级栏目，累计超过（含）5个未更新。</div>
        <div>2. 应更新但长期未更新的其他类栏目数量超过（含）10个。</div>
        <div>3. 空白栏目数量超过（含）5个。</div>
        <div>4. 上述情况出现任意一种，即单项否决。</div>
      </div>
    </div>
    <el-tabs v-model="activeName" style="margin-top:20px" type="card" @tab-click="handleClick">
    <el-tab-pane label="动态要闻类" name="first"></el-tab-pane>
    <el-tab-pane label="通知公告类" name="second"></el-tab-pane>
    <el-tab-pane label="政策文件类" name="third"></el-tab-pane>
    <el-tab-pane label="政策解读类" name="fourth"></el-tab-pane>
    <el-tab-pane label="其他栏目" name="five"></el-tab-pane>
  </el-tabs>
     <div  class="btn-box-fater">
        <div  class="btn-box">
          <div @click="updateModel" class="btn">编辑</div>
          <div>更新周期：{{type == 0?'两周':type == 1 || type == 2 || type == 3?'六个月':'一年'}}</div>
        </div>
        <div v-if="codeData.indexOf('335') != -1 && type == 4"><a-checkbox @change="onChange" :defaultChecked="false" v-model="checked">增量栏目自动进入其他栏目监测范围</a-checkbox></div>
     </div>
    <coententTable
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :customSlot="customSlot"
      :pagination="false"
      :y="height"
    >
      <template v-slot:childrenNumber="scopeVal">
        {{
          scopeVal.scope.childrenNumber > 0
            ? scopeVal.scope.childrenNumber
            : "—"
        }}
      </template>
    </coententTable>
  </a-drawer>
  <ColumModel @cancellation="cancellation" :type="type" :dataSource="dataSource" v-if="dialogVisible" @handleClose="handleClose" :dialogVisible="dialogVisible"></ColumModel>
  </div>
</template>

<script>
import { columnConfigInfoList,addColumnType } from "../index";
import coententTable from "@/components/coentent_table.vue";
import ColumModel from './colum_model.vue'
export default {
  data() {
    return {
      columns: [
        {
          title: "序号",
          dataIndex: "num",
          ellipsis: true,
          width: 80,
           fixed: "left",
        },
        {
          title: "栏目路径",
          dataIndex: "columnName",
          ellipsis: true,
          width: 500,
        },
        {
          title: "子栏目",
          dataIndex: "childrenNumber",
          ellipsis: true,
          width: 100,
          fixed: "right",
          scopedSlots: { customRender: "childrenNumber" },
        },
      ],
      customSlot: [
        {
          name: "childrenNumber",
          customRender: "childrenNumber",
        },
      ],
      dataSource: [],
      loading: false,
      height:0,
      type:0,
      activeName:'first',
      checked:false,
      dialogVisible:false,
      codeData:[],
      width:'',
    };
  },
  components: {
    coententTable,
    ColumModel,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
     this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  watch:{
    visible(val){
        if(val){
            this.getList();
            this.height = document.documentElement.clientHeight - 280;
             this.width = document.documentElement.clientWidth;
            window.onresize = () => {
              return (() => {
                this.height = document.documentElement.clientHeight - 280;
                 this.width = document.documentElement.clientWidth;
              })();
            };
        }
    }
  },
  methods: {
    onChange(){
        addColumnType({
          siteId:sessionStorage.getItem('siteId'),
          addColumnType:this.checked?1:0,
        }).then((res)=>{
            if(res.code == 0){
                this.getList();
            }
        })
    },
    onClose() {
      this.$emit("onClose");
      this.dataSource = [];
      this.type = 0;
      this.activeName = 'first'
    },
    updateModel(){
        this.dialogVisible = true;
    },
    cancellation(){
      this.dialogVisible = false;
    },
     handleClose(){
       this.dialogVisible = false;
       this.getList()
    },
    handleClick(){
        if(this.activeName == 'first'){
            this.type = 0;
        }else if(this.activeName == 'second'){
            this.type = 1;
        }else if(this.activeName == 'third'){
            this.type = 2;
        }else if(this.activeName == 'fourth'){
            this.type = 3;
        }else{
            this.type = 4;
            this.checked = false;
        }
        this.getList();
    },
    getList() {
      this.loading = true;
      columnConfigInfoList({
        siteId: sessionStorage.getItem("siteId"),
        type:this.type,
      }).then((res) => {
        this.dataSource = res.data.responses;
        if(this.type == 4){
            this.checked = res.data.addColumnType?true:false;
        }
        this.loading = false;
        for (let index = 0; index < this.dataSource.length; index++) {
          const element = this.dataSource[index];
          element.num = index + 1;
        }
        this.height = document.documentElement.clientHeight - 300;
        window.onresize = () => {
          return (() => {
            this.height = document.documentElement.clientHeight - 300;
          })();
        };
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-drawer-title {
  color: rgba(48, 49, 51, 1);
  font-size: 18px;
  text-align: left;
  font-family: Roboto-black;
  font-weight: bold;
}
.title-box {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 8px 10px;
  padding-left: 18px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 1px;
    margin-right: -4px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
.btn-box {
  display: flex;
  align-items: center;
  margin: 21px 0px;
  .btn {
    width: 68px;
    height: 36px;
    line-height: 20px;
    border-radius: 4px;
    background-color: rgba(24, 109, 230, 1);
    text-align: center;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    margin-right: 14px;
  }
}
/deep/ .table {
  margin: 0;
}
.btn-box-fater{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/deep/.ant-drawer-close{
    font-size: 16px;
    color: rgba(48, 49, 51, 1);
    font-weight: 800;
}
/deep/.ant-drawer-content{
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
/deep/ .el-tabs__header{
  margin: 0px;
}
</style>